export const CHICAGO_TIME_ZONE = "America/Chicago"

type DateParts = {
  year: number
  month: number
  day: number
  hour: number
  minute: number
  second: number
}

function partsFor(date: Date, timeZone = CHICAGO_TIME_ZONE): DateParts {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date)

  const value = (type: Intl.DateTimeFormatPartTypes) => Number(parts.find((part) => part.type === type)?.value)
  return {
    year: value("year"),
    month: value("month"),
    day: value("day"),
    hour: value("hour"),
    minute: value("minute"),
    second: value("second"),
  }
}

function chicagoOffsetMinutes(date: Date) {
  const parts = partsFor(date)
  const asUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second)
  return (asUtc - date.getTime()) / 60000
}

export function formatChicagoDateTime(value?: string | null) {
  if (!value) return "Not yet"
  return new Intl.DateTimeFormat("en-US", {
    timeZone: CHICAGO_TIME_ZONE,
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  }).format(new Date(value))
}

export function toChicagoDateTimeLocalInputValue(value?: string | null) {
  if (!value) return ""
  const parts = partsFor(new Date(value))
  return `${parts.year}-${String(parts.month).padStart(2, "0")}-${String(parts.day).padStart(2, "0")}T${String(parts.hour).padStart(2, "0")}:${String(parts.minute).padStart(2, "0")}`
}

export function chicagoDateTimeLocalToIso(value: string) {
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/)
  if (!match) return value

  const [, year, month, day, hour, minute] = match.map(Number)
  const wallTimeAsUtc = Date.UTC(year, month - 1, day, hour, minute, 0)
  let candidate = new Date(wallTimeAsUtc - chicagoOffsetMinutes(new Date(wallTimeAsUtc)) * 60000)
  candidate = new Date(wallTimeAsUtc - chicagoOffsetMinutes(candidate) * 60000)
  return candidate.toISOString()
}
